import FacilitiesMapWithLegend from './FacilitiesMapWithLegend';

export default FacilitiesMapWithLegend;
export { default as FacilitiesMapWithLegendLoading } from './FacilitiesMapWithLegendLoading';
